import { useBreakpoint } from '@cat-ecom/pcc-components';
import { CatSkeleton } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';

export const StoreDetailsServerLoader = () => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  return isLG ? (
    <div className="d-flex flex-column px-10 py-10" style={{ gap: '10px' }}>
      <div
        className="d-flex justify-content-around w-100"
        style={{ gap: '10px' }}
      >
        <div className="d-flex col-5">
          <CatSkeleton className="w-100" size="xl" />
        </div>
        <div className="d-flex col-7">
          <CatSkeleton className="w-100" size="xl" />
        </div>
      </div>
      <div
        className="d-flex justify-content-around w-100"
        style={{ gap: '10px' }}
      >
        <div className="d-flex col-5">
          <CatSkeleton className="w-100" size="xl" />
        </div>
        <div className="d-flex col-7" />
      </div>
    </div>
  ) : (
    <div className="d-flex flex-column px-10 py-10 p-1" style={{ gap: '10px' }}>
      <div className="d-flex col-11">
        <CatSkeleton className="w-100" size="xl" />
      </div>
      <div className="d-flex w-100">
        <CatSkeleton className="w-100" size="lg" />
      </div>
      <div className="d-flex col-11">
        <CatSkeleton className="w-100" size="xl" />
      </div>
    </div>
  );
};
